import React, { useEffect, useRef } from "react";
import { Box, Container, Typography } from "@mui/material";

const counters = [
  { value: 16, label: "Satisfied Our Customers" },
  { value: 180, label: "Expert Members" },
  { value: 120, label: "Company Award Winner" },
];

const CounterSection = () => {
  const refs = useRef([]);

  // Simple count-up animation
  useEffect(() => {
    refs.current.forEach((el, index) => {
      if (!el) return;
      let start = 0;
      const end = counters[index].value;
      const duration = 1200;
      const stepTime = Math.max(Math.floor(duration / end), 20);

      const timer = setInterval(() => {
        start += 1;
        el.textContent = start;
        if (start >= end) clearInterval(timer);
      }, stepTime);
    });
  }, []);

  return (
    <>
      <style>{`
        .counter-sec1 {
          padding: 0 0 80px;
          background: #ffffff;
        }

        .counter-card-wrap {
          display: flex;
          align-items: center;
          justify-content: center;
          {/* gap: 40px; */}
          flex-wrap: wrap;
          position: relative;
        }

        .counter-card {
          background: #ffffff;
          border-radius: 20px;
          padding: 40px 50px;
          text-align: center;
          min-width: 260px;
          box-shadow: 0 20px 60px rgba(15, 23, 42, 0.08);
          position: relative;
        }

        .box-number {
          font-size: 48px;
          font-weight: 800;
          color: #111827;
          margin-bottom: 8px;
          line-height: 1;
        }

        .box-number span {
          color: #2563eb;
        }

        .box-text {
          font-size: 16px;
          color: #6b7280;
          margin: 0;
        }

        /* Connector shape */
        .right-shape {
          display: flex;
          align-items: center;
        }

        .right-shape img {
          width: 42px;
          opacity: 0.7;
        }

        /* Responsive */
        @media (max-width: 992px) {
          .counter-card-wrap {
            gap: 30px;
          }
          .right-shape {
            display: none;
          }
        }

        @media (max-width: 600px) {
          .counter-card {
            padding: 32px 28px;
            min-width: 100%;
          }
          .box-number {
            font-size: 40px;
          }
        }
      `}</style>

      {/* SECTION */}
      <Box className="counter-sec1 space-bottom">
        <Box>
          <Box className="counter-card-wrap space">
            {counters.map((item, index) => (
              <React.Fragment key={item.label}>
                <Box className="counter-card">
                  <Box className="media-body">
                    <Typography component="h2" className="box-number">
                      <span
                        ref={(el) => (refs.current[index] = el)}
                        className="counter-number"
                      >
                        0
                      </span>
                       +
                    </Typography>
                 <Typography
  className="box-text"
  sx={{
    color: "#62656aff !important",
    fontSize: "30px",
    m: 0,
    fontWeight: 600,  
  }}
>
  {item.label}
</Typography>


                  </Box>
                </Box>

                {index < counters.length - 1 && (
                  <Box className="right-shape">
                    <img
                      src="https://html.themehour.net/kleanix/demo/assets/img/icon/counter-shape-1-1.png"
                      alt="Shape"
                    />
                  </Box>
                )}
              </React.Fragment>
            ))}
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default CounterSection;
